import {ErrorStateMatcher} from "@angular/material/core";
import {AbstractControl, FormGroupDirective, NgForm} from "@angular/forms";

/** Instruerer material til alltid å vise feil registrert på felter.
 * <pre>
 * Normal viser material først feil når felter er invalid OG dirty (dvs ar bruker har vært innom feltet).
 * Aktiveres på komponentnivå ved å legge til:
 * {provide: ErrorStateMatcher, useClass: VisAlltidFeilErrorStateMatcher} i komponentens providers liste.
 *
 * Se https://material.angular.io/components/input/overview#changing-when-error-messages-are-shown
 * </pre>
 */
export class VisAlltidErrorStateMatcher implements ErrorStateMatcher{
    isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return control?.invalid === true;
    }
}
